import request from '../request';
// import axios from 'axios';
// 获取plan 购买版本信息
// export const mentorOrdersPlans = (params) => {
//   return request({
//     url: '/v1/mentor_orders/plans',
//     method: 'get',
//     params
//   })
// }
// 获取 服务条件详情
export const mentorOrdersNew = (params) => {
  return request({
    url: '/v3/orders/new',
    method: 'get',
    params
  })
}

// 提交 选择服务
export const mentorOrdersCreate = (data) => {
  console.log('mentorOrdersCreate=>',data)
  return request({
    url: '/v4/orders/mentor_orders',
    method: 'POST',
    data
  })
}

export const updateMentorOrder = (token, data) => {
  return request({
    url: `/v4/orders/mentor_orders/${token}`,
    method: 'PUT',
    data
  })
}

// 获取完善信息页
export const mentorOrdersEdit = order_token => {
  return request({
    url: `/v3/orders/mentor_orders/${order_token}`,
    method: 'GET',
    params:{}
  })
}

// 提交完善信息页（能提交问题的页面）
export const putMentorOrdersUpdate = (order_token,data) => {
  return request({
    url: `/v3/orders/mentor_orders/${order_token}`,
    method: 'PUT',
    data
  })
}

// // 提交完善信息成功页（获取订单详情）
// export const mentorOrdersUpdateSuccess = (params) => {
//   return request({
//     url: '/v1/mentor_orders/update_success',
//     method: 'GET',
//     params
//   })
// }

// // 获取二维码
// export const getQrCodeUrl = (params) => {
//   return request({
//     url: '/v1/get_qr_code_url',
//     method: 'GET',
//     params
//   })
// }

// // 轮询用户是否关注公众号
// export const mentorOrdersUserSubscribe = (params) => {
//   return request({
//     url: '/v1/mentor_orders/user_subscribe',
//     method: 'GET',
//     params
//   })
// }

// 同步新增的经历到导师简历
export const mentorCvsSync = cv_token => {
  return request({
    url: `/v3/mentor_cvs/${cv_token}/sync`,
    method: 'POST',
    data:{}
  })
}

// 根据简历token获取导师订单信息
export const getCvTokenMentorOrders = cv_token => {
  return request({
    url: `/v3/cvs/${cv_token}/mentor_orders`,
    method: 'GET',
    params:{}
  })
}

// 判断是否有完善信息的导师订单
export const getNotSelectedMentorOrders = () => {
  return request({
    url: `/v3/orders/mentor_orders/not_selected_mentor_orders`,
    method: 'GET',
    params:{}
  })
}
//创建预付订单
export const  orderPay = (token,data)=>{
  return request({
    url: `/v3/orders/mentor_orders/${token}/pay`,
    method: 'POST',
    data
  })
}
//获取导师订单价格
// export const getOrdersPrice = data =>{
//   return request({
//     url: `/v3/mentor_orders_price/query`,
//     method: 'POST',
//     data:{
//       ...data,
//       channel: 0 // pc的
//     }
//   })
// }
//获取导师订单价格（重构）
export const getOrdersPrice = data =>{
  return request({
    url: `/v4/mentor_orders_price/query`,
    method: 'POST',
    data
  })
}
//手动更改导师任务状态
export const putTaskComplete = task_id =>{
  return request({
    url: `/v3/tasks/${task_id}/complete`,
    method: 'PUT',
    data:{}
  })
}

